import React from 'react'
import { createRegisterableComponent } from '@news-mono/web-common'
import {
    FootyLivesHerePromoCard,
    FootyLivesHerePromoCardProps,
} from './FootyLivesHerePromoCard'

export const FootyLivesHerePromoCardRegistration = createRegisterableComponent(
    'footy-lives-here-promo-card',
    (props: FootyLivesHerePromoCardProps, { onEvent }) => (
        <FootyLivesHerePromoCard {...props} onEvent={onEvent} />
    ),
)
